/**
 * Styled Components - Created by cazarez on 07/02/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  color: var(--neutral-muted);
  display: flex;
  flex-flow: column;
  gap: 18px;
  @media (max-width: 768px) {
    max-width: 50%;
    width: 100%;
    gap: var(--spacing-16);
  }
`

export const Title = styled.div`
  color: var(--neutral-secondary);
  letter-spacing: 1px;
  line-height: 1.25px;
  text-transform: uppercase;
  font: 600 12px/16px var(--font-barlow);
`

export const Text = styled.div`
  transition: color .25s;
  @media (max-width: 768px) {
    font-size: 14px;
  }
  &:hover {
    cursor: pointer;
    color: var(--neutral-white);
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FooterLinks/styledComponents.tsx